export class Point {
    constructor(position, particle) {
        this.position = position;
        this.particle = particle;
    }
}
